// extracted by mini-css-extract-plugin
export default {"cardContainer":"styles_cardContainer__XMbSc","icon":"styles_icon__ktDI-","header":"styles_header__bU1W1","label":"styles_label__AeUtE","value":"styles_value__brB3H"};